<template>
  <div class="chart-name-top liberated-gas-chart-title-wrap" :class="extraClass">
    <span
      class="liberated-gas-chart-title-trigger"
      :class="{ 'is-truncated': isTruncated }"
      :title="isTruncated ? title : undefined"
      @mouseenter="showTooltip"
      @mouseleave="hideTooltip"
    >
      <h6>{{ truncatedTitle }}</h6>
    </span>
    <Teleport to="body">
      <div
        v-if="tooltipVisible"
        class="liberated-gas-title-tooltip"
        :style="tooltipStyle"
        role="tooltip"
      >
        {{ title }}
      </div>
    </Teleport>
  </div>
</template>

<script>
const TITLE_MAX_LENGTH = 30;

export default {
  name: "ChartTitleTooltip",
  props: {
    title: {
      type: String,
      default: "",
    },
    extraClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tooltipVisible: false,
      tooltipStyle: {
        top: "0px",
        left: "0px",
      },
    };
  },
  computed: {
    truncatedTitle() {
      const value = this.title || "";
      return value.length > TITLE_MAX_LENGTH
        ? `${value.slice(0, TITLE_MAX_LENGTH)}...`
        : value;
    },
    isTruncated() {
      return (this.title || "").length > TITLE_MAX_LENGTH;
    },
  },
  methods: {
    showTooltip(event) {
      if (!this.isTruncated) return;

      const rect = event.currentTarget.getBoundingClientRect();
      this.tooltipStyle = {
        top: `${rect.bottom + 6}px`,
        left: `${rect.left}px`,
      };
      this.tooltipVisible = true;
    },
    hideTooltip() {
      this.tooltipVisible = false;
    },
  },
};
</script>
